import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  placeholder = "Search..."
}) => {
  return (
    <div className="relative w-full max-w-full">
      <div className="absolute inset-y-0 left-0 pl-2 md:pl-3 flex items-center pointer-events-none">
        <MagnifyingGlassIcon className="h-4 w-4 md:h-5 md:w-5 text-gray-500 dark:text-gray-400" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="block w-full pl-8 md:pl-10 pr-2 md:pr-3 py-1.5 md:py-2 border border-gray-300 dark:border-gray-600 rounded-md leading-5 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-xs md:text-sm shadow-sm"
        placeholder={placeholder}
      />
    </div>
  );
};

export default SearchBar; 